module.exports = __webpack_public_path__ + "img/md-light-deeppurple.df80990d.svg";